// Dollars <-> integer cents conversion for the price input field. Prices are
// always stored and sent as integer minor units; floats live only in the UI.

/** Format integer cents as a plain dollars string for a text input (1999 -> "19.99"). */
export function centsToInput(cents: number): string {
  if (!Number.isFinite(cents)) return "";
  return (cents / 100).toFixed(2);
}

/**
 * Parse a user-entered dollars string into integer cents.
 * Returns null for empty/non-numeric/negative input so callers can show an error.
 */
export function inputToCents(input: string): number | null {
  const trimmed = input.trim();
  if (!trimmed) return null;
  // Allow an optional leading "$" and thousands separators the user might type.
  const normalized = trimmed.replace(/^\$/, "").replace(/,/g, "");
  if (!/^\d*(\.\d+)?$/.test(normalized)) return null;
  const dollars = Number(normalized);
  if (!Number.isFinite(dollars) || dollars < 0) return null;
  return Math.round(dollars * 100);
}
